import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import othersSelector from '@app/redux/others/selector';
import { useLocation } from 'react-router-dom';
import { BUTTON_ACTION_TYPE } from '@app/components/UI/Button';

export const useAuthButton = (buttonType) => {
    const location = useLocation();

    const [isAuth, setIsAuth] = useState(false);
    const listRoute = useSelector(othersSelector.routeList);

    useEffect(() => {
        if (buttonType) {
            if (location.pathname === '/') {
                setIsAuth(true);
            } else {
                const routeCheck = listRoute.find(
                    (item) =>
                        (item?.path ?? '').toLowerCase() ===
                        (location?.pathname ?? '').toLowerCase(),
                );

                if (routeCheck) {
                    const { roles } = routeCheck;
                    if (roles && roles.length > 0) {
                        let isCheck = false;
                        if (roles[0] === 1) {
                            isCheck = true;
                        } else {
                            switch (buttonType) {
                                case BUTTON_ACTION_TYPE.SEARCH: {
                                    isCheck = roles[2] === 1;
                                    break;
                                }
                                case BUTTON_ACTION_TYPE.ADD: {
                                    isCheck = roles[3] === 1;
                                    break;
                                }
                                case BUTTON_ACTION_TYPE.PASSWORD:
                                case BUTTON_ACTION_TYPE.SAVE:
                                case BUTTON_ACTION_TYPE.EDIT: {
                                    isCheck = roles[4] === 1;
                                    break;
                                }

                                case BUTTON_ACTION_TYPE.DELETE: {
                                    isCheck = roles[5] === 1;
                                    break;
                                }
                                case BUTTON_ACTION_TYPE.PRINT:
                                case BUTTON_ACTION_TYPE.EXPORT_FILE: {
                                    isCheck = roles[6] === 1;
                                    break;
                                }

                                default: {
                                    break;
                                }
                            }
                        }
                        setIsAuth(isCheck);
                    }
                }
            }
        }
    }, [location.pathname, buttonType, listRoute]);

    return isAuth;
};
